// extracted by mini-css-extract-plugin
export default {"root":"PageLayout_root__tYqSQ","loaderContainer":"PageLayout_loaderContainer__myNH2","pageContainer":"PageLayout_pageContainer__FDyC4","loader":"PageLayout_loader__66wGZ"};